import { A11yModule } from '@angular/cdk/a11y';
import { ComponentType } from '@angular/cdk/portal';
import {
  Component,
  ElementRef,
  OnDestroy,
  ViewContainerRef,
  inject,
  viewChild,
} from '@angular/core';
import { Subject } from 'rxjs';

import { VerticalOffsetDirective } from '../private/vertical-offset.directive';

import { DIALOG_CONFIG } from './tokens';

@Component({
  selector: 'plugins-dialog',
  imports: [A11yModule, VerticalOffsetDirective],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  host: {
    '(window:keydown.escape)': 'onKeydown()',
  },
})
export class DialogComponent implements OnDestroy {
  readonly dialogRef =
    viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

  private readonly vcr = viewChild.required('vcr', { read: ViewContainerRef });

  readonly config = inject(DIALOG_CONFIG);

  #closed$ = new Subject<unknown>();
  closed$ = this.#closed$.asObservable();
  #close?: () => void;

  open<T>(component: ComponentType<T>, close: () => void) {
    this.#close = close;
    const content = this.vcr().createComponent(component);
    this.dialogRef().nativeElement.show();
    return content;
  }

  close(val?: unknown) {
    this.#closed$.next(val);
    this.dialogRef().nativeElement.close();
    this.vcr().remove();
    this.#close?.();
  }

  onKeydown() {
    this.close();
  }

  ngOnDestroy(): void {
    this.#closed$.complete();
  }
}
